module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Title-Page.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-21"
  }, [_c('p', {
    staticClass: "pl-title"
  }, [_vm._v("Deadly Identity")]), _vm._v(" "), _c('p', {
    staticClass: "pl-author"
  }, [_vm._v("Lindsay McKenna")]), _vm._v(" "), _c('p', {
    staticClass: "pl-logo"
  }, [_c('img', {
    staticClass: "PL-Logos",
    attrs: {
      "alt": "Har_HQN_2012_Cab_Blk.ai",
      "src": "images/logo.png"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c4fc044","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Title_1.vue
// module id = 69
// module chunks = 0